import { graphql } from 'gatsby'
import React, { useCallback, useEffect, useState } from 'react'
import ArticlesList from '../components/article/ArticlesList'
import WithInputSearch from '../components/HOC/WithInputSearch'
import Input from '../components/Input'
import Tag from '../components/Tag'

export const QUERY_KEY_TYPE = 'type'
export const QUERY_KEY_Q = 'q'

const RecentArticlesSection = ({ slice, context }) => {
  const { primary, items } = slice

  const [searchedValue, setSearchedValue] = useState('')
  const [category, setCategory] = useState('')

  const handleChangeInput = useCallback((val) => setSearchedValue(val), [])
  const handleFilterCategory = useCallback((val) => {
    setCategory(val)
    const url = new URL(window?.location)
    url.searchParams.set(QUERY_KEY_TYPE, encodeURIComponent(val))
    window?.history?.pushState(null, '', url.toString())
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window?.location?.search)
    const query = params.get(QUERY_KEY_TYPE)
    if (query) {
      setCategory(decodeURIComponent(query))
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window?.location?.search)
    const query = params.get(QUERY_KEY_Q)

    setSearchedValue(query || '')
  }, [])

  return (
    <section className={`section recent-articles-section ${primary?.page}`}>
      <div className="container">
        {primary?.title1?.text && (
          <h3 className="title">{primary?.title1?.text}</h3>
        )}
        <div className="search-box">
          <WithInputSearch type={context.type} value={searchedValue}>
            <Input
              type={'search'}
              placeholder={primary?.input_placeholder.text}
              value={searchedValue}
              onChange={handleChangeInput}
            />
          </WithInputSearch>
          <div className="divider" />
          <div className="tags-box">
            {items?.map((tag) => {
              const category = tag?.article_category
              return (
                <button
                  className="tag-button"
                  key={tag}
                  onClick={() => handleFilterCategory(category)}
                >
                  <Tag text={category} type={category} />
                </button>
              )
            })}
          </div>
        </div>
        <ArticlesList
          category={category}
          data={context.relatedArticlesData}
          type={context.type}
        />
      </div>
    </section>
  )
}

export default RecentArticlesSection

export const query = graphql`
  fragment ArticlesOverviewPageDataBodyResentArticlesSection on PrismicArticlesOverviewPageDataBodyResentArticlesSection {
    id
    primary {
      title1 {
        text
      }
      input_placeholder {
        text
      }
    }
    items {
      article_category
    }
  }
  fragment ArticlesSearchPageDataBodyResentArticlesSection on PrismicArticlesSearchPageDataBodyResentArticlesSection {
    id
    primary {
      title1 {
        text
      }
      input_placeholder {
        text
      }
    }
    items {
      article_category
    }
  }
`
